var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M57.42,1.38,56.5.46a1.55,1.55,0,0,0-2.2,0L29,25.77,3.69.46a1.55,1.55,0,0,0-2.2,0l-.92.92a1.55,1.55,0,0,0,0,2.2L27.89,30.91a1.57,1.57,0,0,0,2.2,0L57.4,3.58A1.53,1.53,0,0,0,57.42,1.38Z","transform":"translate(-0.11)"}));
}

ArrowDown.defaultProps = {"id":"b5fab9db-3c77-4b66-8b3a-b0edc797c4ee","data-name":"Layer 1","viewBox":"0 0 57.76 31.36","width":"100%","height":"100%"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
